import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
} from "@mui/material";

const services = [
  {
    title: "Business analysis",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/ba.png",
  },
  {
    title: "UX and UI design",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/uiux.png",
  },
  {
    title: "Product Architecture",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/architecture.png",
  },
  {
    title: "Front-end development",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/front-end.png",
  },
  {
    title: "Back-end development",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/backend.png",
  },
  {
    title: "Integration",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/intigration.png",
  },
  {
    title: "Testing and QA",
    description:
      "Your online solution's faultless functionality, performance, usability, and security are guaranteed by our committed team of testing engineers.",
    icon: "/img/icons/testing.png",
  },
  {
    title: "Help desk",
    description:
      "Our experienced group of business analysts is committed to comprehending your target market and identifying their particular requirements. They act as the vital conduit between our IT specialists and your business stakeholders, guaranteeing smooth coordination between all parties.",
    icon: "/img/icons/help.png",
  },
  {
    title: "Continuous Support and Evolution",
    description:
      "Our commitment to your web-based software extends beyond development. We proactively enhance your solution to ensure it remains efficient, competitive in the market, and aligned with your evolving business requirements.",
    icon: "/img/icons/support.png",
  },
];

const WebDevelopmentServices = () => {
  return (
    <Box
      sx={{
        color: "white",
        textAlign: "center",
        p: 4,
      }}
    >
      <Container>
        <Box
          sx={{
            padding: 5,
            border: "1px solid #DADFEF80",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#0A2C43B2",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              mb: 2,
              color: "white",
            }}
          >
            Superior Web Development Services with an Emphasis on Quality
          </Typography>
          <Typography
            sx={{
              maxWidth: "800px",
              mx: "auto",
              mb: 4,
              color: "white",
            }}
          >
            Europa Solutions is dedicated to providing top-notch web development
            services. We focus on quality, backed by our certification that
            guarantees a strong quality management system...
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            {services.map((service, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={index === services.length - 1 ? 12 : 6}
                key={index}
              >
                <Card
                  sx={{
                    backgroundColor: "transparent",
                    color: "white",
                    textAlign: "center",
                    p: 2,
                    borderRadius: 3,
                    boxShadow: 3,
                    border: "3px solid #DADFEF",
                    height: "100%",
                    transition: "background 0.3s ease",
                    "&:hover": {
                      background: "linear-gradient(to bottom, grey, #9D3DBA)",
                    },
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 1,
                        color: "#00c9a7",
                      }}
                    >
                      <img
                        src={service.icon}
                        alt="Service icon"
                        style={{ width: 101, height: 101 }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "20px",
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography sx={{ color: "white", fontSize: "16px" }}>
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default WebDevelopmentServices;
